import Entity from 'utilities/entity';

class Spark extends Entity {}

export default new Spark();
